export const buildFilterPayload = (values: any, includeSearch: boolean = true, entity: string, store_id: string, page: number, limit: number) => {
    return {
      ...(values.selectList && { ...values.selectList }),
      entity: entity,
      ...(store_id && { store_id: Number(store_id) }),
      page: page ?? 1,
      limit: limit ?? 10,
      ...(includeSearch && values.search && { search: values.search }),
    };
  };
